export { fetchPlatformIdentity, getShortBuildSha, type PlatformIdentity } from '@/platformIdentity'

export function getBuildSha(): string {
  return import.meta.env.VITE_APP_SHA ?? ''
}
